import React from "react";
import { IconButton, Grid } from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterListOutlined";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import {
  useCreateInvoicesFilter,
  useCurrentCreateInvoicesFilter,
} from "../../../data/accounting/createInvoices/hooks/useCreateInvoicesFilter";
import { LocalizationContext } from "../../../core/localization/Localization";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import { CreateInvoicesFilterEditor } from "./CreateInvoicesEditor";
import { CreateInvoiceFilterChips } from "./CreateInvoiceFilterChips";

export const CreateInvoicesFilter: React.FunctionComponent = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  const showFilter = React.useCallback(
    () => showWithDrawer(<CreateInvoicesFiltersEditor />),
    [showWithDrawer]
  );

  //  const [filter, editfilter, save] = useCreateInvoicesFilter();
  const [filter, removefilter] = useCurrentCreateInvoicesFilter();
  const { getString } = React.useContext(LocalizationContext);

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <CreateInvoiceFilterChips filter={filter} removefilter={removefilter} />
      </Grid>
      <Grid item>
        <CustomTooltip titleKeyword="filterTooltip">
          <IconButton color="secondary" component="span" onClick={showFilter}>
            <FilterIcon />
          </IconButton>
        </CustomTooltip>
      </Grid>
    </Grid>
  );
};

const CreateInvoicesFiltersEditor: React.FunctionComponent = () => {
  const [filter, editFilter, save] = useCreateInvoicesFilter();
  return (
    <CreateInvoicesFilterEditor
      filter={filter}
      editFilter={editFilter}
      save={save}
    />
  );
};
